import { render, staticRenderFns } from "./paymentModuleAdmin.vue?vue&type=template&id=f82f4aba&scoped=true&"
import script from "./paymentModuleAdmin.vue?vue&type=script&lang=js&"
export * from "./paymentModuleAdmin.vue?vue&type=script&lang=js&"
import style0 from "./paymentModuleAdmin.vue?vue&type=style&index=0&id=f82f4aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82f4aba",
  null
  
)

export default component.exports